import React from "react";
import AnimatedSection from "../common/AnimatedSection";

const FutureSection = () => {
  return (
    <section style={styles.futureSection}>
      <div style={styles.futureOverlay}></div>
      <div style={styles.container}>
        <AnimatedSection animation="fadeIn">
          <h2 style={styles.sectionTitle}>
            Elevating <span style={styles.highlight}>Tomorrow's World</span>
          </h2>
          <p style={styles.sectionSubtitle}>
            Building a future where vertical mobility transforms urban living
            through sustainable innovation and technological excellence
          </p>
          <div style={styles.sectionDivider}></div>

          <div style={styles.futureContent}>
            <div style={styles.futureCard}>
              <div style={styles.cardHeader}>
                <i
                  className="fas fa-chart-line"
                  style={styles.cardHeaderIcon}
                ></i>
                <h3 style={styles.futureCardTitle}>
                  Transformative Growth Strategy 2025-2030
                </h3>
              </div>
              <ul style={styles.futureList}>
                <li style={styles.futureItem}>
                  <i className="fas fa-globe-asia" style={styles.itemIcon}></i>
                  <div style={styles.itemContent}>
                    <strong style={styles.itemTitle}>Regional Expansion</strong>
                    <p style={styles.itemText}>
                      Strengthening our presence in Jaipur and Agra while
                      methodically expanding to neighboring cities across
                      Rajasthan, Uttar Pradesh and Delhi-NCR
                    </p>
                  </div>
                </li>
                <li style={styles.futureItem}>
                  <i className="fas fa-flask" style={styles.itemIcon}></i>
                  <div style={styles.itemContent}>
                    <strong style={styles.itemTitle}>R&D Innovation Hub</strong>
                    <p style={styles.itemText}>
                      Pioneering next-generation elevator technologies with
                      advanced AI integration and seamless smart building
                      connectivity
                    </p>
                  </div>
                </li>
                <li style={styles.futureItem}>
                  <i className="fas fa-handshake" style={styles.itemIcon}></i>
                  <div style={styles.itemContent}>
                    <strong style={styles.itemTitle}>
                      Strategic Partnerships
                    </strong>
                    <p style={styles.itemText}>
                      Forging transformative alliances with regional developers
                      and industry leaders to enhance technological capabilities
                      and expand market reach
                    </p>
                  </div>
                </li>
                <li style={styles.futureItem}>
                  <i className="fas fa-chart-bar" style={styles.itemIcon}></i>
                  <div style={styles.itemContent}>
                    <strong style={styles.itemTitle}>Sustainable Growth</strong>
                    <p style={styles.itemText}>
                      Driving consistent 15% year-over-year revenue expansion
                      while setting new benchmarks in quality and service
                      excellence
                    </p>
                  </div>
                </li>
                <li style={styles.futureItem}>
                  <i className="fas fa-award" style={styles.itemIcon}></i>
                  <div style={styles.itemContent}>
                    <strong style={styles.itemTitle}>Service Excellence</strong>
                    <p style={styles.itemText}>
                      Revolutionizing customer experience through AI-powered
                      service platforms and next-generation predictive
                      maintenance systems
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {/* <div style={styles.futureCard}>
              <div style={styles.cardHeader}>
                <i
                  className="fas fa-flag-checkered"
                  style={styles.cardHeaderIcon}
                ></i>
                <h3 style={styles.futureCardTitle}>
                  Innovation Roadmap to Excellence
                </h3>
              </div>

              <div style={styles.timeline}>
                <div style={styles.timelineLine}></div>

                <div style={styles.timelineItem}>
                  <div style={styles.timelinePointContainer}>
                    <div style={styles.timelinePoint}></div>
                    <div style={styles.timelinePointRipple}></div>
                  </div>
                  <div style={styles.timelineContent}>
                    <div style={styles.timelineBadge}>
                      <i className="fas fa-hand-sparkles"></i>
                    </div>
                    <h4 style={styles.timelineDate}>2023</h4>
                    <h5 style={styles.timelineTitle}>Touchless Revolution</h5>
                    <p style={styles.timelineText}>
                      Successfully launched our groundbreaking smart elevator
                      ecosystem with intuitive gesture control and touchless
                      operation, setting new standards for safety and user
                      experience in the post-pandemic era.
                    </p>
                  </div>
                </div>

                <div style={styles.timelineItem}>
                  <div style={styles.timelinePointContainer}>
                    <div style={styles.timelinePoint}></div>
                    <div style={styles.timelinePointRipple}></div>
                  </div>
                  <div style={styles.timelineContent}>
                    <div style={styles.timelineBadge}>
                      <i className="fas fa-building"></i>
                    </div>
                    <h4 style={styles.timelineDate}>2024</h4>
                    <h5 style={styles.timelineTitle}>
                      Service Hub Enhancement
                    </h5>
                    <p style={styles.timelineText}>
                      Strengthening our operations in Jaipur and Agra with
                      enhanced service centers, expanded technical teams, and
                      improved customer experience facilities to build a solid
                      foundation for future growth.
                    </p>
                  </div>
                </div>

                <div style={styles.timelineItem}>
                  <div style={styles.timelinePointContainer}>
                    <div style={styles.timelinePoint}></div>
                    <div style={styles.timelinePointRipple}></div>
                  </div>
                  <div style={styles.timelineContent}>
                    <div style={styles.timelineBadge}>
                      <i className="fas fa-leaf"></i>
                    </div>
                    <h4 style={styles.timelineDate}>2025</h4>
                    <h5 style={styles.timelineTitle}>
                      Sustainable Mobility Ecosystem
                    </h5>
                    <p style={styles.timelineText}>
                      Unveiling our revolutionary EcoLift platform featuring
                      advanced energy regeneration technology, integrated solar
                      capabilities, and biodegradable materials designed for
                      tomorrow's green buildings.
                    </p>
                  </div>
                </div>


              </div>
            </div> */}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

const styles = {
  futureSection: {
    padding: "120px 0",
    backgroundImage: "url(/images/about/future-bg.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    position: "relative",
    color: "white",
    overflow: "hidden",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
    position: "relative",
    zIndex: 2,
  },
  sectionTitle: {
    fontSize: "3rem",
    fontWeight: "800",
    textAlign: "center",
    marginBottom: "10px",
    color: "white",
    textShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
  },
  sectionSubtitle: {
    fontSize: "1.2rem",
    textAlign: "center",
    maxWidth: "700px",
    margin: "0 auto 20px",
    color: "rgba(255, 255, 255, 0.9)",
  },
  highlight: {
    background: "linear-gradient(90deg, #4ade80 0%, #3b82f6 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textShadow: "none",
  },
  sectionDivider: {
    width: "80px",
    height: "4px",
    background: "linear-gradient(90deg, #4ade80 0%, #3b82f6 100%)",
    margin: "0 auto 60px",
    borderRadius: "2px",
  },
  futureOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(135deg, rgba(17, 24, 39, 0.95) 0%, rgba(9, 15, 31, 0.85) 100%)",
  },
  futureContent: {
    display: "flex",
    flexWrap: "wrap",
    gap: "30px",
    justifyContent: "center",
  },
  futureCard: {
    flex: "1 1 45%",
    minWidth: "300px",
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
    backdropFilter: "blur(10px)",
    padding: "35px",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 25px 50px rgba(0, 0, 0, 0.15)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
  },
  cardHeaderIcon: {
    fontSize: "2.5rem",
    marginRight: "20px",
    color: "#4ade80",
  },
  futureCardTitle: {
    fontSize: "1.8rem",
    fontWeight: "700",
    color: "white",
    margin: 0,
  },
  futureList: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "22px",
  },
  futureItem: {
    display: "flex",
    alignItems: "flex-start",
    padding: "5px 0",
    minHeight: "85px",
  },
  itemIcon: {
    fontSize: "1.5rem",
    color: "#4ade80",
    marginRight: "20px",
    marginTop: "5px",
    flexShrink: 0,
    width: "24px",
    textAlign: "center",
  },
  itemContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  itemTitle: {
    display: "block",
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: "8px",
    color: "white",
  },
  itemText: {
    fontSize: "1rem",
    lineHeight: "1.6",
    margin: "0",
    color: "rgba(255, 255, 255, 0.8)",
  },
  timeline: {
    position: "relative",
    padding: "15px 0 0",
  },
  timelineLine: {
    position: "absolute",
    left: "15px",
    top: "0",
    bottom: "0",
    width: "2px",
    background:
      "linear-gradient(to bottom, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.1) 100%)",
    zIndex: 1,
  },
  timelineItem: {
    position: "relative",
    paddingLeft: "60px",
    marginBottom: "22px",
  },
  timelinePointContainer: {
    position: "absolute",
    left: "8px",
    top: "5px",
    zIndex: 2,
  },
  timelinePoint: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "linear-gradient(90deg, #4ade80 0%, #3b82f6 100%)",
    border: "3px solid white",
    boxShadow: "0 0 10px rgba(74, 222, 128, 0.5)",
  },
  timelinePointRipple: {
    position: "absolute",
    top: "-4px",
    left: "-4px",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid rgba(74, 222, 128, 0.5)",
    animation: "ripple 2s infinite ease-out",
  },
  timelineContent: {
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
    backdropFilter: "blur(10px)",
    padding: "20px 25px",
    borderRadius: "15px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    position: "relative",
    transition: "transform 0.3s ease",
    minHeight: "85px",
  },
  timelineBadge: {
    position: "absolute",
    right: "20px",
    top: "20px",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    background: "rgba(74, 222, 128, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.1rem",
    color: "#4ade80",
  },
  timelineDate: {
    fontSize: "1.3rem",
    fontWeight: "800",
    margin: "0 0 6px",
    background: "linear-gradient(90deg, #4ade80 0%, #3b82f6 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  timelineTitle: {
    fontSize: "1.15rem",
    fontWeight: "700",
    margin: "0 0 8px",
    color: "white",
  },
  timelineText: {
    fontSize: "1rem",
    lineHeight: "1.6",
    margin: "0",
    color: "rgba(255, 255, 255, 0.8)",
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2)",
      opacity: 0,
    },
  },
  "@media (max-width: 992px)": {
    sectionTitle: {
      fontSize: "2.5rem",
    },
    futureCard: {
      padding: "30px",
    },
  },
  "@media (max-width: 820px)": {
    futureSection: {
      padding: "90px 0",
      backgroundAttachment: "scroll",
    },
    sectionTitle: {
      fontSize: "2.2rem",
    },
    sectionSubtitle: {
      fontSize: "1.1rem",
    },
    cardHeaderIcon: {
      fontSize: "2rem",
    },
    futureCardTitle: {
      fontSize: "1.6rem",
    },
    futureContent: {
      gap: "40px",
    },
  },
  "@media (max-width: 576px)": {
    futureSection: {
      padding: "70px 0",
    },
    sectionTitle: {
      fontSize: "1.8rem",
    },
    sectionDivider: {
      margin: "0 auto 40px",
    },
    futureCard: {
      padding: "25px",
    },
    cardHeader: {
      flexDirection: "column",
      textAlign: "center",
    },
    cardHeaderIcon: {
      marginRight: "0",
      marginBottom: "15px",
    },
    timelineItem: {
      paddingLeft: "45px",
    },
    timelineContent: {
      padding: "18px",
    },
  },
};

export default FutureSection;
